import api from '@/shared/services/api';
import types from './types.js';
import router from '../router/index.js';
import routerNames from '../router/router-names.js';

/// Reads LoanEnquiryConfig from remote API 
/// Returns: False or Configuration Data
/// ********************************************
const getLoanEnquiryConfig = async function () {
  try {
    return parseResponse(await api.get(types.apiRoot + types.LOAN_ENQUIRY_CONFIGURATION_READ));
  }
  catch (error) {
    console.error(error);
    router.push({ name: routerNames.Timeout });
    return false;
  }
};

/// POST remote API
/// ***********************************************
const saveLoanEnquiry = async function (payload) {return postRequest(types.LOAN_ENQUIRY_CREATE, payload)};
const checkEligibility = async function (payload) { return postRequest(types.LOAN_ENQUIRY_CHECK_ELIGIBILITY, payload); };
const otpRequest = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OTP_REQUEST, payload); };
const otpValidate = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OTP_VALIDATE, payload); };
const requestOpen = async function (payload) { return postRequest(types.LOAN_ENQUIRY_REQUEST_OPEN, payload); };
const openEnquiry = async function (payload) { return postRequest(types.LOAN_ENQUIRY_OPEN_ENQUIRY, payload); };
const enquiryDoc = async function (payload) { return postRequest(types.LOAN_ENQUIRY_ENQUIRY_DOCUMENT, payload); };
const enquiryIdVerification = async function (payload) { return postRequest(types.LOAN_ENQUIRY_ENQUIRY_ID_VERIFICATION, payload); };
const generateSignature = async function (payload) { return postRequest(types.LOAN_ENQUIRY_GENERATE_SIGNATURE, payload); };

/// Generic Post Request
/// **************************************************
const postRequest = async function (action, payload) {
  try {
    return parseResponse(await api.post(types.apiRoot + action, payload));
  }
  catch (error) {
    console.error(error);
    router.push({ name: routerNames.Error });
    return false;
  }
};

/// Parse JSON response
/// ***************************
const parseResponse = response => {
  if (response.status !== 200) throw Error(response.message);
  return !response.data || typeof response.data != 'object' ? [] : response.data;
};

export const service = {
  getLoanEnquiryConfig,
  saveLoanEnquiry, 
  checkEligibility, 
  otpRequest, 
  otpValidate, 
  requestOpen, 
  openEnquiry, 
  enquiryDoc,
  enquiryIdVerification,
  generateSignature
};